import ValueTracker from "../../prop-trackers/value-tracker.js";
import PropChainTracker from "../../prop-tracker-utils/prop-chain-tracker.js";
import SinglePropChainTracker from "../../prop-tracker-utils/single-prop-chain-tracker.js";
import DictTrackerObjPtrGen from "../../prop-tracker-utils/dict-tracker-obj-ptr-gen.js";

import LabelObjectPosMapper from "./trackers/labels/label-object-pos-mapper.js";

class LiveLabelPositions {
    constructor(wrapCtx, evtCtx) {
        this._labelObjTracker = new PropChainTracker(evtCtx);
        this._objPosTracker = new SinglePropChainTracker(evtCtx);
        this._labelObjPosMapper = new LabelObjectPosMapper(this._labelObjTracker, wrapCtx, evtCtx);
        this._posGen = new DictTrackerObjPtrGen(wrapCtx, evtCtx, this._labelObjPosMapper);
    }

    get positions() { return this._posGen.pointer; }

    track(liveLabelObjects, objOnScreenPos) {
        if (liveLabelObjects) {
            this._labelObjTracker.track(liveLabelObjects.data, ["value"]);
        } else {
            this._labelObjTracker.track();
        }

        if (objOnScreenPos) {
            this._objPosTracker.track(objOnScreenPos.data, ["value"]);
        } else {
            this._objPosTracker.track();
        }

        if (liveLabelObjects || objOnScreenPos) {
            this._posGen.start();
        } else {
            this._posGen.stop();
        }
    }

    update() {
        this._objPosTracker.updateIfNeeded(({ prop: { newValue } }) => {
            this._labelObjPosMapper.trackObjectPositions(newValue);
        });

        this._posGen.update();
    }
}

export default LiveLabelPositions;
